import React from "react";
import { Button, Divider, Modal } from "../../../../components";


const ResendModal = ({ open, onClose }) => {
  return (
    <div>
      <Modal
        isOpen={open}
        onClose={onClose}
        title="INVOICE EMAIL PREVIEW "
        width="max-w-7xl"
      >
        <div className="px-4">
          <div>
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">To:</div>
              <div className="w-full">
                <div className="flex justify-between">
                  <div>ap@vdart.inc.com</div>
                  <div className="text-primary">Cc Bcc</div>
                </div>
                <Divider />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">CC:</div>
              <div className="w-full">
                ap@vdart.inc.com
                <Divider />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">Subject:</div>
              <div className="w-full">
                ap@vdart.inc.com
                <Divider />
              </div>
            </div>
          </div>
          <div className="border-[1px] border-neutrals-50 rounded my-4 p-3 min-h-80">
            Hello VDart Inc,
          </div>
          <div className="mt-4">
            <p>ATTACHMENTS</p>
            <Divider />
            <div className="flex gap-3 mt-2">
              <div className="bg-info-50 flex rounded-md items-center">
                <Button
                  icon="docs"
                  title={"Attachment 1.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
                <Button
                  type={"icon"}
                  icon="close"
                  title={"Attachment 1.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <p>Approved Timesheet Attachments</p>
            <Divider />
            <div className="flex mt-2">
              <div className="bg-info-50 flex rounded-md items-center">
                <Button
                  icon="docs"
                  title={"RameshMaharthi03001.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
                <Button
                  type={"icon"}
                  icon="close"
                  title={"Attachment 1.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <p>Invoice Attachments</p>
            <Divider />
            <div className="flex mt-2">
              <div className="bg-info-50 flex rounded-md items-center">
                <Button
                  icon="docs"
                  title={"invoice.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
                <Button
                  type={"icon"}
                  icon="close"
                  title={"Attachment 1.pdf"}
                  variant="text"
                  color="black"
                  size={"sm"}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <Button title={"Cancel "} variant="outlined" onClick={onClose} />
            <Button title={"Save"} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ResendModal;
